package one.healthium.pilates.ui.workouts

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.paint
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ifaandroid.apps.pilates.composeapp.generated.resources.Res
import ifaandroid.apps.pilates.composeapp.generated.resources.bg_workouts_topbar
import loco.TODAY_MEAL_PLAN_SECTION
import loco.PILATES_TODAY_SCREEN_TITLE
import loco.PILATES_TODAY_WORKOUTS_SECTION
import one.healthium.healthKit.ui.HealthKitConnectBanner
import one.healthium.healthKit.ui.HealthKitConnectBannerContract
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.ui.components.ContentRenderer
import one.healthium.meal_plans.domain.MealPlanInfoModel
import one.healthium.pilates.ui.workouts.components.MealPlanInfoCard
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.components.AppLoadingScreen
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppSeparator
import one.healthium.ui.compose.components.AppTopBar
import one.healthium.ui.compose.components.AppTopBarDefaults
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

interface WorkoutsEventDelegate {
    fun onActionClicked(action: ActionModel)
}

@Composable
fun WorkoutsScreen(eventDelegate: WorkoutsEventDelegate) {
    val viewModel = koinViewModel<WorkoutsViewModel>()
    val state by viewModel.state.collectAsState()

    WorkoutsScreenContent(
        state = state,
        onActionClicked = eventDelegate::onActionClicked,
        healthKitContract = viewModel,
        onMealPlanClicked = { eventDelegate.onActionClicked(ActionModel.MealPlan(it.id)) }
    )

    AlertUiMessageHandler(viewModel.uiMessages)
}

@Composable
private fun WorkoutsScreenContent(
    state: WorkoutsUiState,
    onActionClicked: (ActionModel) -> Unit,
    healthKitContract: HealthKitConnectBannerContract,
    onMealPlanClicked: (MealPlanInfoModel) -> Unit,
) {
    val painter = painterResource(Res.drawable.bg_workouts_topbar)
    AppScaffold(
        topBar = {
            AppTopBar(
                modifier = Modifier.paint(painter = painter, contentScale = ContentScale.Crop),
                colors = AppTopBarDefaults.colors(Color.Transparent),
                title = {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            text = stringResource(loco.Res.string.PILATES_TODAY_SCREEN_TITLE),
                            style = LocalTextStyle.current.copy(fontSize = 24.sp),
                        )
                    }
                }
            )
        }
    ) {
        Box(modifier = Modifier.padding(it)) {
            val content = state.content
            if (content != null) {
                ContentRenderer(
                    contentPadding = PaddingValues(top = 6.dp, bottom = 90.dp),
                    content = content.content,
                    onActionClicked = onActionClicked,
                    isMetrics = state.isMetrics,
                    headerContent = {
                        if (state.shouldShowHKBanner) {
                            Spacer(Modifier.height(18.dp))
                            HealthKitConnectBanner(contract = healthKitContract)
                        }
                        if (state.mealPlan != null) {
                            AppSeparator(
                                modifier = Modifier.padding(horizontal = 12.dp),
                                text = stringResource(loco.Res.string.TODAY_MEAL_PLAN_SECTION),
                            )
                            MealPlanInfoCard(
                                mealPlan = state.mealPlan,
                                onClick = { onMealPlanClicked(state.mealPlan) },
                            )
                        }
                        AppSeparator(
                            modifier = Modifier.padding(horizontal = 12.dp),
                            text = stringResource(loco.Res.string.PILATES_TODAY_WORKOUTS_SECTION),
                        )
                    }
                )
            }
            AppLoadingScreen(visible = state.loading)
        }
    }
}
